module.exports = __webpack_public_path__ + "static/media/arrow-square-right.e191dcad.svg";